/**
 * Usable Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const USABLE = 'usable';
